/** Admin: platform-wide secret values (global fallback for $secret refs). */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { GlobalSecretEntry } from '../types.js';

export function listGlobalSecrets(): Promise<GlobalSecretEntry[]> {
  return apiGet<GlobalSecretEntry[]>('/api/v1/admin/global-secrets');
}

export function setGlobalSecret(fieldKey: string, value: unknown): Promise<void> {
  return apiPut<void>(
    `/api/v1/admin/global-secrets/${encodeURIComponent(fieldKey)}`,
    { value },
  );
}

export function deleteGlobalSecret(fieldKey: string): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/global-secrets/${encodeURIComponent(fieldKey)}`,
  );
}
